import { render, staticRenderFns } from "./DetailsNavigationButtons.vue?vue&type=template&id=4616985c&scoped=true&"
import script from "./DetailsNavigationButtons.vue?vue&type=script&lang=js&"
export * from "./DetailsNavigationButtons.vue?vue&type=script&lang=js&"
import style0 from "./DetailsNavigationButtons.vue?vue&type=style&index=0&id=4616985c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4616985c",
  null
  
)

export default component.exports